/**
 * @param {string} str
 * @returns str param with the first letter capitalized
 */
export default function capitalize(str) {
  if (!str) return "";
  return str?.charAt(0)?.toUpperCase() + str.slice(1);
}
